import StubPage from "./StubPage";
import { Accessibility, HandHeart, Trophy, Sparkles } from "lucide-react";
export default function Para() {
  return <StubPage eyebrow="Para Karate" title="Inclusive Karate for Every Athlete"
    subtitle="Special children, para athletes and differently-abled karatekas are central to NKF Bharat's inclusivity mission."
    sections={[
      { icon: Accessibility, title: "Special Children", body: "Adaptive karate programmes for special children, run under licensed federation coaches at affiliated centres." },
      { icon: Trophy, title: "Para Athletes", body: "Dedicated para karate categories at every national event with classification standards aligned with IPC norms." },
      { icon: HandHeart, title: "Support Programs", body: "Equipment grants, travel support and dedicated coaching for the para karate national squad." },
      { icon: Sparkles, title: "Inclusive Pathway", body: "From grass-roots to international para karate competition — a complete federation pathway." },
    ]}
  />;
}
